:host {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 16px;
  position: relative;
}
:host .vx-payback-inner {
  display: flex;
  align-items: center;
  gap: 16px;
}
:host .vx-payback-logo {
  height: 36px;
  width: auto;
  margin: 0;
}
:host .vx-payback-text-container {
  color: var(--vx-payback-text-color, #908787);
}
:host .vx-payback-text-container p {
  margin: 0;
  font-size: var(--vx-payback-text-font-size, 0.75rem);
  line-height: var(--vx-payback-text-line-height, 0.88rem);
  font-weight: var(--vx-payback-text-font-weight, 400);
}
:host .vx-payback-points {
  color: var(--vx-payback-color, #0046aa);
  font-size: var(--vx-payback-points-font-size, 0.75rem);
  font-weight: var(--vx-payback-points-font-weight, 400);
  line-height: var(--vx-payback-points-line-height, 0.88rem);
}
:host .info-circle {
  justify-self: flex-start;
  height: 24px;
  width: 24px;
  border: 1px solid var(--vx-payback-text-color, #908787);
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
:host .info-circle .info-icon {
  font-size: 14px;
  color: var(--vx-payback-text-color, #908787);
}
:host .info-tooltip {
  grid-column: 1/4;
  display: grid;
  grid-template-rows: auto auto auto;
  grid-template-columns: 1fr 1fr;
}
:host .info-tooltip-headline {
  grid-row: 1/2;
  grid-column: 1/3;
  font-size: var(--vx-payback-header-font-size, 1.25rem);
  color: var(--vx-payback-color, #0046aa);
  margin-top: 0;
}
:host .info-tooltip-text {
  grid-row: 2/3;
  grid-column: 1/3;
  font-size: var(--vx-payback-info-card-font-size, 0.875rem);
  line-height: var(--vx-payback-info-card-line-height, 1.125rem);
  font-weight: var(--vx-payback-info-card-font-weight, 400);
}
:host .info-tooltip-text .payback-points {
  font-weight: bold;
  display: block;
}
:host .info-tooltip-button {
  grid-row: 3/4;
  grid-column: 1/2;
  justify-self: flex-start;
}
:host .info-tooltip-logo {
  grid-row: 3/4;
  grid-column: 2/3;
  justify-self: flex-end;
}